<div class="location-line-container">
    <img src="assets/icons/location-marker.svg" class="location-icon" alt="Start Location" />
    <div class="location-line"></div>
    <img src="assets/icons/location-marker.svg" class="location-icon" alt="End Location" />
</div>